<template>
<li v-on:click.stop="toggleAlarmList()">
  <!--<a class="large-screen">
    <li class="large-screen">{{ $t('views.navbar.lastnotification') }}:&nbsp;</li>
    <i class="warning-icon left warning-text" v-if="lastStatusRailObject.MonitorStatusId === 2"></i>
    <i class="alarm-icon left alarm-text" v-if="lastStatusRailObject.MonitorStatusId === 3"></i>
    {{lastNotificationInMinutes}} {{ $tc('views.navbar.minutes', lastNotificationInMinutes) }} {{ $t('views.navbar.ago') }} <i class="material-icons right">arrow_drop_down</i>
    </a>
  <a class="medium-screen small-screen">
    <li class="medium-screen small-screen">Last:&nbsp;</li>
    <i class="material-icons left warning-text" v-if="lastStatusRailObject.MonitorStatusId === 2">error</i>
    <i class="material-icons left alarm-text" v-if="lastStatusRailObject.MonitorStatusId === 3">warning</i>
    {{lastNotificationInMinutes}} min ago <i class="material-icons right">arrow_drop_down</i>
    </a>-->
  <a v-on:click.stop="toggleAlarmList()"><i class="material-icons right">notifications_none</i>&nbsp;</a>
  <div class="alarm-list z-depth-1" v-if="alarmList">
    <table class="striped highlight">
      <tbody>
        <tr class="clickable" v-for="railObject in railObjectsInWarningOrError.slice(0, 5)" v-bind:key="railObject.RailObjectId" v-on:click="showDetail(railObject)">
          <td class="alarm-list-type">{{railObject.DataSourceCode.substring(0, 2)}}</td>
          <td class="alarm-list-switch">{{railObject.ComplexName}}\{{railObject.Name}}</td>
          <td class="alarm-list-datetime">{{railObject.StatusMeasurementDateTime | formatDate}}</td>
          <td class="alarm-list-status warning-text" v-if="railObject.MonitorStatusId === 2"><i class="material-icons left">error</i></td>
          <td class="alarm-list-status alarm-text" v-if="railObject.MonitorStatusId === 3"><i class="material-icons left">warning</i></td>
        </tr>

        <tr class="clickable">
          <td colspan="5" class="alarm-list-button">
            <div class="row-button" v-on:click="gotoAlarmList()">
              <i class="material-icons">list</i>
              {{ $t('views.navbar.openallnotifications') }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</li>
</template>

<script>
import moment from 'moment'
import Router from '../../router/index'
import UtilitiesService from '../../services/UtilitiesService'
import RailObjectService from '../../services/RailObjectService'
import RailObjectsApi from '../../services/api/RailObjectsApi'

export default {
  name: 'AlarmList',
  data () {
    return {
      railObjectsInWarningOrError: [],
      lastNotificationInMinutes: undefined,
      lastStatusRailObject: {},
      alarmList: false
    }
  },
  created: function () {
    this.setAlarmList()

    RailObjectService.subscribe((type, oldVal, newVal) => {
      switch (type) {
        case 'setRailObjects':
          this.setAlarmList()
          break
        case 'updateRailObject':
          this.setAlarmList()
          break
      }
    })
  },
  mounted: function () {
    setInterval(() => {
      this.setNewRailobjects()
    }, 31873) // set it on a prime number to interfere less with other timed queries
    this.$root.$el.addEventListener('click', this.rootClick)
  },
  methods: {
    setNewRailobjects: async function () {
      await RailObjectsApi.getNewRailObjects(RailObjectService.getRailObjects().length).then(result => {
        if (result && result.data && result.data !== null && result.data !== undefined && result.data.length > 0) {
          RailObjectService.setRailObjects(result.data)
          this.setAlarmList()
        }
      })
    },
    toggleAlarmList: function () {
      if (!this.alarmList) {
        this.$root.$el.click()
      }
      this.alarmList = !this.alarmList
    },
    setAlarmList: function () {
      this.railObjectsInWarningOrError = []
      RailObjectService.getRailObjects().forEach((railObject) => {
        if (railObject) {
          if (railObject.StatusMeasurementDateTime) {
            railObject.StatusMeasurementDateTime = railObject.StatusMeasurementDateTime.substring(0, 19)
            railObject.timestamp = moment(String(railObject.StatusMeasurementDateTime), 'YYYY-MM-DDTHH:mm:ss').toDate().getTime()

            if (railObject.OperationModeId === 5) {
            } else {
              switch (railObject.MonitorStatusId) {
                case 1:
                  break
                case 2:
                  this.railObjectsInWarningOrError.push(railObject)
                  break
                case 3:
                  this.railObjectsInWarningOrError.push(railObject)
                  break
                default:
                  break
              }
            }
          }
        }
      })
      this.railObjectsInWarningOrError = UtilitiesService.sortByKey(this.railObjectsInWarningOrError, 'timestamp').reverse()
      this.lastStatusRailObject = this.railObjectsInWarningOrError[0]
      if (this.lastStatusRailObject) {
        if (this.lastStatusRailObject.StatusMeasurementDateTime) {
          this.lastNotificationInMinutes = Math.round(((new Date()).getTime() - this.lastStatusRailObject.timestamp) / 1000 / 60)
        }
      }
    },
    showDetail: function (railObject) {
      Router.push({
        name: 'Switch',
        params: {
          id: railObject.RailObjectId,
          measurementId: railObject.LastMeasurementId
        },
        props: true
      })
    },
    gotoAlarmList: function (railObject) {
      Router.push({
        name: 'AlarmList'
      })
    },
    rootClick: function () {
      this.alarmList = false
    }
  },
  watch: {
    /* 'railObjects': {
      handler: function (val, oldVal) {
        this.setAlarmList()
      },
      deep: true
    } */
  },
  beforeDestroy: function () {
    this.$root.$el.removeEventListener('click', this.rootClick)
  }
}
</script>

<style>
.alarm-list {
  width: 800px;
  left: -743px;
  background-color: #fff;
  z-index: 1000;
  position: absolute;
  line-height: initial;
  color: #000;
}

.alarm-list-button {
  text-align: center;
}

.alarm-list-type, .alarm-list-status {
  width: 36px;
  text-align: center;
}

.alarm-list-switch {
  text-align: left;
}

.alarm-list-datetime {
  width: 170px;
  text-align: center;
}

.alarm-list-percentage {
  width: 80px;
  text-align: center;
}

.alarm-list-status i {
  margin: 0px;
  line-height: 20px !important;
  height: 20px !important;
}

.alarm-icon {
  width: 30px;
  background-image: url(../../assets/alarm-icon.svg);
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 5px !important;
}

.warning-icon {
  width: 30px;
  background-image: url(../../assets/warning-icon.svg);
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 5px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/nav/_AlarmList.vue